import React from 'react'
import Grid from '../../../../../ui/grid'
import SelectChild from './select-child'

export const transformForAPI = values =>
  Object.assign({}, values, { children: compactChildrenArray(values.children) })

export const validate = ({ children }) => compactChildrenArray(children).length > 0

export const compactChildrenArray = (children = []) => children.filter(val => val)

export const SelectChildren = ({ records = [], onChange, values = {} }) => (
  <fieldset>
    <legend>Select a child</legend>
    At least one child needs to be selected
    <Grid small>
      {records.map((enrolmentID, i) => (
        <SelectChild
          key={i}
          mapKey={i}
          enrolmentID={enrolmentID}
          onChange={onChange}
          values={values}
        />
      ))}
    </Grid>
  </fieldset>
)

export default SelectChildren



// WEBPACK FOOTER //
// ./src/iss-case-claims/details/case-claim/form/select-children/index.js